import React, { useState } from "react";
import { Badge } from "../../../../ui/components/Badge";

import ReviewChangesModal, { ChangeItem } from "./ReviewChangesModal";

interface DocumentMetadataData {
  source: string;
  uploadedBy: string;
  uploadTimestamp: string;
  fileName: string;
}

interface DocumentMetadataOptionsData {
  uploadedBy: string[];
  uploadTimestamp: string[];
  fileName: string[];
}

interface DocumentMetadataEditableFieldProps {
  initialData: DocumentMetadataData;
  optionsData?: DocumentMetadataOptionsData;
  onSave?: (newData: DocumentMetadataData) => void;
  disabled?: boolean;
}

const DocumentMetadataEditableField: React.FC<
  DocumentMetadataEditableFieldProps
> = ({
  initialData = {
    source: "INVOICE",
    uploadedBy: "John Smith",
    uploadTimestamp: "March 15, 2024 10:30 AM",
    fileName: "invoice_march_2024.pdf",
  },
  optionsData = {
    uploadedBy: [],
    uploadTimestamp: [],
    fileName: [],
  },
  onSave,
  disabled = false,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [data, setData] = useState<DocumentMetadataData>(initialData);
  const [editData, setEditData] = useState<DocumentMetadataData>(initialData);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [pendingChanges, setPendingChanges] = useState<ChangeItem[]>([]);

  const handleEdit = () => {
    setEditData(data);
    setIsEditing(true);
  };

  const handleSave = () => {
    // Check for changes and create change items
    const changes: ChangeItem[] = [];

    Object.keys(editData).forEach((key) => {
      const fieldKey = key as keyof DocumentMetadataData;
      if (data[fieldKey] !== editData[fieldKey]) {
        changes.push({
          field:
            key.charAt(0).toUpperCase() +
            key.slice(1).replace(/([A-Z])/g, " $1"),
          previousValue: data[fieldKey],
          newValue: editData[fieldKey],
        });
      }
    });

    if (changes.length > 0) {
      setPendingChanges(changes);
      setIsReviewModalOpen(true);
    } else {
      setIsEditing(false);
    }
  };

  const handleCancel = () => {
    setEditData(data);
    setIsEditing(false);
  };

  const handleConfirmChanges = () => {
    setData(editData);
    setIsEditing(false);
    setIsReviewModalOpen(false);
    setPendingChanges([]);
    // Optional callback to parent component this will update the json !! to be used to send to DB later
    onSave?.(editData);
  };

  const handleCancelChanges = () => {
    setIsReviewModalOpen(false);
    setPendingChanges([]);
    // Keep editing mode open so user can continue editing
  };

  // const handleFieldChange = (
  //   field: keyof DocumentMetadataData,
  //   value: string
  // ) => {
  //   setEditData((prev) => ({ ...prev, [field]: value }));
  // };

  // const handleKeyPress = (e: React.KeyboardEvent) => {
  //   if (e.key === "Enter") {
  //     handleSave();
  //   } else if (e.key === "Escape") {
  //     handleCancel();
  //   }
  // };

  // const isFieldEmpty = (value: string) => !value || value.trim() === "";

  // const getSuggestions = (field: keyof DocumentMetadataOptionsData) => {
  //   return optionsData[field] || [];
  // };

  // const shouldShowSuggestion = (field: keyof DocumentMetadataData) => {
  //   if (isFieldEmpty(data[field])) {
  //     const optionsField = field as keyof DocumentMetadataOptionsData;
  //     if (optionsData[optionsField].length > 0) {
  //       return true;
  //     }
  //   }
  //   return false;
  // };

  return (
    <div className="flex w-full flex-col items-start gap-3 border-b border-solid border-neutral-100 pb-4">
      <div className="flex w-full items-center justify-between">
        <span className="text-body-bold font-body-bold text-subtext-color">
          Document Metadata
        </span>
        {/* {isEditing ? (
          <div className="flex items-center gap-2">
            <Button variant="brand-primary" size="small" onClick={handleSave}>
              <FeatherSave />
            </Button>
            <Button
              variant="neutral-tertiary"
              size="small"
              onClick={handleCancel}
            >
              <FeatherX />
            </Button>
          </div>
        ) : (
          <FeatherEdit
            className="text-body-bold font-body-bold text-subtext-color cursor-pointer hover:text-brand-600 transition-colors"
            onClick={handleEdit}
          />
        )} */}
      </div>
      <div className="w-full items-start gap-4 grid grid-cols-3">
        <div className="flex grow shrink-0 basis-0 flex-col items-start gap-1">
          <span className="text-body font-body text-subtext-color">Source</span>
          <Badge>{data.source}</Badge>
        </div>
        <div className="flex grow shrink-0 basis-0 flex-col items-start gap-1">
          <div className="flex items-center gap-2">
            <span className="text-body font-body text-subtext-color">
              Uploaded By
            </span>
            {/* {shouldShowSuggestion("uploadedBy") && (
              <SubframeCore.Tooltip.Provider>
                <SubframeCore.Tooltip.Root>
                  <SubframeCore.Tooltip.Trigger asChild={true}>
                    <FeatherInfo className="text-body font-body text-error-700" />
                  </SubframeCore.Tooltip.Trigger>
                  <SubframeCore.Tooltip.Portal>
                    <SubframeCore.Tooltip.Content
                      side="top"
                      align="center"
                      sideOffset={4}
                      asChild={true}
                    >
                      <div className="flex min-w-[240px] flex-col items-start gap-2 rounded-md border border-solid border-neutral-border bg-white px-3 py-2 shadow-md">
                        <span className="text-caption-bold font-caption-bold text-default-font">
                          Possible Matches:
                        </span>
                        <div className="flex flex-col items-start gap-1">
                          {getSuggestions("uploadedBy").map(
                            (suggestion, index) => (
                              <span
                                key={index}
                                className="text-caption font-caption text-brand-600 cursor-pointer hover:text-brand-800"
                                onClick={() => {
                                  if (isEditing) {
                                    handleFieldChange("uploadedBy", suggestion);
                                  } else {
                                    setData((prev) => ({
                                      ...prev,
                                      uploadedBy: suggestion,
                                    }));
                                  }
                                }}
                              >
                                • {suggestion}
                              </span>
                            )
                          )}
                        </div>
                      </div>
                    </SubframeCore.Tooltip.Content>
                  </SubframeCore.Tooltip.Portal>
                </SubframeCore.Tooltip.Root>
              </SubframeCore.Tooltip.Provider>
            )} */}
          </div>
          {/* {isEditing ? (
            <TextField label="" helpText="">
              <TextField.Input
                placeholder="John Smith"
                value={editData.uploadedBy}
                onChange={(e) =>
                  handleFieldChange("uploadedBy", e.target.value)
                }
                onKeyDown={handleKeyPress}
              />
            </TextField>
          ) : (
            <span className="text-body-bold font-body-bold text-default-font">
              {data.uploadedBy}
            </span>
          )} */}
          <span className="text-body-bold font-body-bold text-default-font">
            {data.uploadedBy}
          </span>
        </div>
        <div className="flex grow shrink-0 basis-0 flex-col items-start gap-1">
          <div className="flex items-center gap-2">
            <span className="text-body font-body text-subtext-color">
              Upload Timestamp
            </span>
            {/* {shouldShowSuggestion("uploadTimestamp") && (
              <SubframeCore.Tooltip.Provider>
                <SubframeCore.Tooltip.Root>
                  <SubframeCore.Tooltip.Trigger asChild={true}>
                    <FeatherInfo className="text-body font-body text-error-700" />
                  </SubframeCore.Tooltip.Trigger>
                  <SubframeCore.Tooltip.Portal>
                    <SubframeCore.Tooltip.Content
                      side="top"
                      align="center"
                      sideOffset={4}
                      asChild={true}
                    >
                      <div className="flex min-w-[240px] flex-col items-start gap-2 rounded-md border border-solid border-neutral-border bg-white px-3 py-2 shadow-md">
                        <span className="text-caption-bold font-caption-bold text-default-font">
                          Possible Matches:
                        </span>
                        <div className="flex flex-col items-start gap-1">
                          {getSuggestions("uploadTimestamp").map(
                            (suggestion, index) => (
                              <span
                                key={index}
                                className="text-caption font-caption text-brand-600 cursor-pointer hover:text-brand-800"
                                onClick={() => {
                                  if (isEditing) {
                                    handleFieldChange(
                                      "uploadTimestamp",
                                      suggestion
                                    );
                                  } else {
                                    setData((prev) => ({
                                      ...prev,
                                      uploadTimestamp: suggestion,
                                    }));
                                  }
                                }}
                              >
                                • {suggestion}
                              </span>
                            )
                          )}
                        </div>
                      </div>
                    </SubframeCore.Tooltip.Content>
                  </SubframeCore.Tooltip.Portal>
                </SubframeCore.Tooltip.Root>
              </SubframeCore.Tooltip.Provider>
            )} */}
          </div>
          {/* {isEditing ? (
            <TextField label="" helpText="">
              <TextField.Input
                placeholder="March 15, 2024 10:30 AM"
                value={editData.uploadTimestamp}
                onChange={(e) =>
                  handleFieldChange("uploadTimestamp", e.target.value)
                }
                onKeyDown={handleKeyPress}
              />
            </TextField>
          ) : (
            <span className="text-body-bold font-body-bold text-default-font">
              {data.uploadTimestamp}
            </span>
          )} */}
          <span className="text-body-bold font-body-bold text-default-font">
            {data.uploadTimestamp}
          </span>
        </div>
        <div className="flex grow shrink-0 basis-0 flex-col items-start gap-1 col-span-2">
          <div className="flex items-center gap-2">
            <span className="text-body font-body text-subtext-color">
              File Name
            </span>
            {/* {shouldShowSuggestion("fileName") && (
              <SubframeCore.Tooltip.Provider>
                <SubframeCore.Tooltip.Root>
                  <SubframeCore.Tooltip.Trigger asChild={true}>
                    <FeatherInfo className="text-body font-body text-error-700" />
                  </SubframeCore.Tooltip.Trigger>
                  <SubframeCore.Tooltip.Portal>
                    <SubframeCore.Tooltip.Content
                      side="top"
                      align="center"
                      sideOffset={4}
                      asChild={true}
                    >
                      <div className="flex min-w-[240px] flex-col items-start gap-2 rounded-md border border-solid border-neutral-border bg-white px-3 py-2 shadow-md">
                        <span className="text-caption-bold font-caption-bold text-default-font">
                          Possible Matches:
                        </span>
                        <div className="flex flex-col items-start gap-1">
                          {getSuggestions("fileName").map(
                            (suggestion, index) => (
                              <span
                                key={index}
                                className="text-caption font-caption text-brand-600 cursor-pointer hover:text-brand-800"
                                onClick={() => {
                                  if (isEditing) {
                                    handleFieldChange("fileName", suggestion);
                                  } else {
                                    setData((prev) => ({
                                      ...prev,
                                      fileName: suggestion,
                                    }));
                                  }
                                }}
                              >
                                • {suggestion}
                              </span>
                            )
                          )}
                        </div>
                      </div>
                    </SubframeCore.Tooltip.Content>
                  </SubframeCore.Tooltip.Portal>
                </SubframeCore.Tooltip.Root>
              </SubframeCore.Tooltip.Provider>
            )} */}
          </div>
          {/* {isEditing ? (
            <TextField label="" helpText="">
              <TextField.Input
                placeholder="invoice_march_2024.pdf"
                value={editData.fileName}
                onChange={(e) => handleFieldChange("fileName", e.target.value)}
                onKeyDown={handleKeyPress}
              />
            </TextField>
          ) : (
            <span className="text-body-bold font-body-bold text-default-font">
              {data.fileName}
            </span>
          )} */}
          <span className="text-body-bold font-body-bold text-default-font">
            {data.fileName}
          </span>
        </div>
      </div>

      {/* Review Changes Modal */}
      <ReviewChangesModal
        open={isReviewModalOpen}
        onOpenChange={setIsReviewModalOpen}
        changes={pendingChanges}
        onConfirm={handleConfirmChanges}
        onCancel={handleCancelChanges}
        title="Review Document Metadata Changes"
        description="These changes will affect the invoice calculations and tax implications. Please review carefully before proceeding."
      />
    </div>
  );
};

export default DocumentMetadataEditableField;
